import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Stack, Switch, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { camelCase_to_Sentence, toTitleCase } from '../../../../../helpers/format';
import { Arbitrator, AttributeModiferKeys } from './Arbitrator';
const INITIAL = false;
export const BooleanAttribute = (props) => {
    const { name, attribute, rangeLimits, disable, isRoot } = props;
    const [checked, setChecked] = useState(false);
    const [toggled, setToggled] = useState(INITIAL);
    const disabled = isRoot ? !checked : disable;
    useEffect(() => {
        if (disabled)
            setChecked(false);
        if (toggled !== INITIAL && disabled)
            setToggled(INITIAL);
    }, [disabled, toggled]);
    const more = [];
    const payload = {};
    let valid = !disabled;
    const { attributeType, ...others } = rangeLimits;
    for (const [key, other] of Object.entries(others)) {
        if (!AttributeModiferKeys.includes(key)) {
            const { elements, payload: p, valid: v, } = Arbitrator({
                name: key,
                attribute,
                rangeLimits: other,
                disable: isRoot ? !checked : disable,
                isRoot: false,
            });
            more.push(elements);
            payload[name] ??= {};
            if (p[key] !== undefined)
                payload[name][key] = p[key];
            valid = valid && v;
        }
    }
    const readableName = toTitleCase(camelCase_to_Sentence(name));
    if (!disabled)
        payload[name] = toggled;
    const present = isRoot && _jsx(Checkbox, { checked: checked, onChange: (e) => setChecked(e.target.checked), disabled: disable });
    const control = _jsx(Switch, { checked: toggled, onChange: (e) => setToggled(e.target.checked), disabled: disabled });
    const elements = more.length ? (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [present, _jsx(Typography, { children: readableName }), control, _jsxs(Stack, { gap: 1, children: [...more] })] })) : (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [present, !isRoot && _jsx(Typography, { color: disabled ? 'textDisabled' : undefined, children: readableName }), control] }));
    return { elements, payload, valid };
};
